<template>
  <div
    class="affiliate-message text-center pa-2 weight_500 clr-yellow b-radius_4 f-center position-relative"
    style="
      background-color: rgba(0, 0, 0, 0.3);
      border: 1px solid rgba(255, 184, 0, 0.75);
      height: 3rem;
    "
  >
    <div
      v-if="price_type === 'AFFILIATE'"
      v-html="
        $t('subscription.discount_eligible_message', {
          affiliate_name,
          value: `${cheapPlan.discount}%`,
        })
      "
    />
    <div
      v-else-if="price_type === 'DISCOUNT'"
      v-html="
        $t('subscription.discount_simple_message', {
          value: `${cheapPlan.discount}%`,
        })
      "
    />

    <!-- style="position: absolute; right: 0.5rem" -->
    <div
      v-if="price_type === 'AFFILIATE'"
      class="csst"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'left' })"
    >
      <i class="mdi mdi-information-outline text-semi-large ml-2" />
      <div
        class="csst_content csst_content_hoverable clr-white text-left"
        style="position: fixed; max-width: 32rem"
        v-html="$t('tooltips.affliate_discount', { affiliate_name })"
      ></div>
    </div>

    <slot />
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'

export default {
  name: 'AffiliateMessage',
  mixins: [float_mix],
  props: {
    cheapPlan: Object,
  },
  data() {
    return {}
  },

  computed: {
    price_type() {
      return this.cheapPlan?.price_type
    },
    affiliate_name() {
      return this.$store.getters.user_info.affiliate_name
    },
  },
}
</script>

<style lang="scss" scoped>
// .affiliate-message {
// background: rgba(255, 255, 255, 0.1);
// background-color: rgba(0, 0, 0, 0.3);
// }
</style>
